import axios from 'axios';
import {baseUrl} from "../utilities/config";

export const postDocuments = (data,url) => {

    let config = {
        method: 'post',
        url: `${baseUrl}${url}`,
        headers: {
            "Content-Type": "multipart/form-data"
        },
        data : data
    };

    return axios(config)
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            return error.response
        });

}

export const getDocuments = (data,url) => {

    let config = {
        method: 'post',
        url: `${baseUrl}${url}`,
        headers: {
            'Content-Type': 'application/json'
        },
        data : data
    };

    return axios(config)
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            return error.response
        });

}

